import { render, staticRenderFns } from "./ordersReport.vue?vue&type=template&id=29e64070"
import script from "./ordersReport.vue?vue&type=script&lang=js"
export * from "./ordersReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports